import type { CustomRouteSegment } from '../../types/CustomRoute';
import { isSinglePointSegment } from './validation';

// A segment's handles sit where its paths meet: handle i is the start of path i, and the end handle is the end of the last
// path. A segment drawn down to a single point has one path with one point, and that point is its only handle.

type SegmentPaths = Pick<CustomRouteSegment, 'paths'>;

/** The index of a segment's last handle */
export const getEndHandleIndex = (segment: SegmentPaths) => (isSinglePointSegment(segment) ? 0 : segment.paths.length);

/** How many handles a segment has: none without paths */
export const getHandleCount = (segment: SegmentPaths) => (segment.paths.length === 0 ? 0 : getEndHandleIndex(segment) + 1);

/**
 * The handle a new path added at the selected handle becomes, as addActiveSegmentPath adds it: the segment's first point, the
 * second point of a single point segment, a new start before the start handle, or the handle after the selected one (a new end,
 * or the far end of an out-and-back inserted at an inner handle). Undefined when addActiveSegmentPath would add nothing.
 */
export const getAddedHandleIndex = (segment: SegmentPaths | undefined, selectedHandleIndex: number | undefined) => {
  if (!segment) {
    return undefined;
  }
  if (segment.paths.length === 0) {
    return 0;
  }
  if (selectedHandleIndex === undefined || selectedHandleIndex > segment.paths.length) {
    return undefined;
  }
  if (isSinglePointSegment(segment)) {
    return 1;
  }
  return selectedHandleIndex === 0 ? 0 : selectedHandleIndex + 1;
};
